import React from 'react';
import { Loader2, Printer, type LucideIcon } from 'lucide-react';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@roger/ui-components';

/** A full-width download-menu row for a billing document. */
export const BillingPdfMenuRow: React.FC<{
  label: string;
  title: string;
  isDownloading: boolean;
  onClick: () => void;
  icon?: LucideIcon;
}> = ({ label, title, isDownloading, onClick, icon: Icon = Printer }) => (
  <Button
    type='button'
    variant='ghost'
    onClick={onClick}
    disabled={isDownloading}
    className='w-full justify-start gap-2 text-muted-foreground hover:text-foreground'
    aria-label={label}
    title={title}
  >
    {isDownloading ? (
      <Loader2 className='h-4 w-4 animate-spin' />
    ) : (
      <Icon className='h-4 w-4' />
    )}
    {label}
  </Button>
);

/** The icon-only counterpart of `BillingPdfMenuRow`, with a tooltip. */
export const BillingDownloadIconButton: React.FC<{
  label: string;
  isDownloading: boolean;
  onClick: () => void;
  icon?: LucideIcon;
}> = ({ label, isDownloading, onClick, icon: Icon = Printer }) => (
  <TooltipProvider delayDuration={300}>
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type='button'
          variant='ghost'
          size='icon'
          onClick={onClick}
          disabled={isDownloading}
          className='text-muted-foreground hover:text-foreground'
          aria-label={label}
        >
          {isDownloading ? (
            <Loader2 className='h-4 w-4 animate-spin' />
          ) : (
            <Icon className='h-4 w-4' />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent side='bottom' className='text-xs'>
        {label}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
